import React from "react";
import { useNavigate } from "react-router-dom";
import { TaskListItem as TaskListItemType } from "@myapp/contract";
import { formatDateDDMMYYYY } from "../../../../shared/helpers/date";
import { formatSollIst } from "../../../../shared/helpers/duration";
import { ListItem } from "../../../../shared/ui/list/ListIteam/ListItem";
import { aufgabenColumns } from "../model/constants";
import { getTaskTypeLabel, getTaskStatusLabel, NEEDS_RESCHEDULING_LABEL } from "../../../../entities/task";
import { routes } from "../../../../shared/config/routes";

interface Props {
  item: TaskListItemType;
}

function formatScheduledDateRange(plannedStart: string, plannedWorkDurationMinutes: number): string {
  const start = new Date(plannedStart);
  const end = new Date(start.getTime() + plannedWorkDurationMinutes * 60 * 1000);

  const datePart = formatDateDDMMYYYY(plannedStart);
  const startTime = `${String(start.getHours()).padStart(2, "0")}:${String(start.getMinutes()).padStart(2, "0")}`;
  const endTime = `${String(end.getHours()).padStart(2, "0")}:${String(end.getMinutes()).padStart(2, "0")}`;

  return `${datePart} ${startTime} - ${endTime}`;
}


export const AufgabenListItem: React.FC<Props> = ({ item }) => {
  const navigate = useNavigate();

  const datum = item.plannedStart
    ? formatScheduledDateRange(item.plannedStart, item.plannedWorkDuration)
    : "—";
  const abgabefrist = item.deadline ? formatDateDDMMYYYY(item.deadline) : "—";
  const soll = formatSollIst(item.plannedTravelDuration, item.plannedWorkDuration, item.plannedDepartureDuration);
  const ist = formatSollIst(item.actualTravelDuration, item.actualWorkDuration, item.actualDepartureDuration);

  return (
    <div
      onClick={() => navigate(routes.aufgaben.edit(item.id))}
    >
      <ListItem columns={aufgabenColumns}>
        <ListItem.Cell>{item.title}</ListItem.Cell>
        <ListItem.Cell>{item.assignedTechnician?.fullName ?? "—"}</ListItem.Cell>
        <ListItem.Cell>{getTaskTypeLabel(item.taskType)}</ListItem.Cell>
        <ListItem.Cell>{item.needsRescheduling ? NEEDS_RESCHEDULING_LABEL : getTaskStatusLabel(item.status)}</ListItem.Cell>
        <ListItem.Cell>{datum}</ListItem.Cell>
        <ListItem.Cell>{abgabefrist}</ListItem.Cell>
        <ListItem.Cell>{soll}</ListItem.Cell>
        <ListItem.Cell>{ist}</ListItem.Cell>
      </ListItem>
    </div>
  );
};
